<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  fetchDegradingPotential() {
    return axios.get('potenciais-degradadores', AS.getDefaultHeaders());
  },
  createDegradingPotential(degradingPotential) {
    return axios.post('potenciais-degradadores', { degrading_potential: degradingPotential }, AS.getDefaultHeaders());
  },
};
</script>
